<template>
  <el-dialog
    title="选择代理方"
    class="dialog"
    :visible.sync="dialogVisible"
    width="800px"
    :before-close="handleClose"
  >
    <span><i class="red-dot">*</i>请选择代理机构及经办人</span>
    <div class="l-inbox m-t-20">
      <!-----------代理机构搜索------------>
      <div class="l-left">
        <el-input
          v-model="keyword"
          placeholder="请输入代理机构名称"
          clearable
          @submit.native.prevent
          @keyup.enter.native="searchAgentList"
        >
          <el-button
            slot="append"
            type="primary"
            @click="searchAgentList"
          >搜索</el-button>
        </el-input>
        <el-table
          ref="agentTable"
          border
          :data="agentList"
          style="width: 100%"
          class="m-t-20"
          size="medium"
          :show-header="false"
          highlight-current-row
          @current-change="handleAgentCurrentChange"
        >
          <el-table-column prop="companyName" label="企业名称" min-width="150">
            <template slot-scope="scope">
              <span :class="{ disabled: scope.row.companyId === companyId }">
                {{ scope.row.companyName }}
              </span></template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="agentListPage.total > 0"
          ref="pagination"
          :background="false"
          :layout="`prev, pager, next`"
          :pager-count="5"
          :total="agentListPage.total"
          :page.sync="agentListPage.page"
          :limit.sync="agentListPage.size"
          @pagination="getAgentList"
        />
      </div>

      <!-----------员工搜索------------>
      <div class="l-right">
        <el-input
          v-model="name"
          placeholder="输入姓名查询"
          clearable
          @submit.native.prevent
          @keyup.enter.native="searchEmployeeList"
        >
          <el-button
            slot="append"
            type="primary"
            @click="searchEmployeeList"
          >搜索</el-button>
        </el-input>

        <div v-if="!currentCompanyInfo.companyId" class="employee-search-tip">
          <p>请先选择代理机构</p>
        </div>

        <div v-else>
          <el-table
            ref="employeeTable"
            :data="employeeList"
            size="medium"
            style="width: 100%"
            class="m-t-20"
            :show-header="false"
            highlight-current-row
            @current-change="handleEmployeeCurrentChange"
          >
            <el-table-column
              prop="name"
              label="姓名"
              min-width="60"
              show-overflow-tooltip
            />
            <el-table-column
              prop="mobile"
              label="联系方式"
              min-width="100"
              show-overflow-tooltip
            />
            <el-table-column
              prop="deptName"
              label="部门"
              min-width="140"
              show-overflow-tooltip
            />
          </el-table>
          <pagination
            v-show="employeeListPage.total > 0"
            ref="pagination"
            :background="false"
            :layout="`prev, pager, next`"
            :total="employeeListPage.total"
            :page.sync="employeeListPage.page"
            :limit.sync="employeeListPage.size"
            @pagination="getEmployeeList"
          />
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitAgency">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import Pagination from '@/components/common/Pagination'
import { searchAgencyListApi, getEmployeeListHasAgencyApi } from '@/api/company'

import { mapState } from 'vuex'
export default {
  components: {
    Pagination
  },

  props: {
    // 所选择的代理机构信息
    agentInfo: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      dialogVisible: false,
      // 代理机构查询
      keyword: '',
      tempKeyword: '', // 临时存储代理机构名称，为了翻页时候回显
      agentList: [],
      currentCompanyInfo: {}, // 选中行代理机构
      initCompanyInfo: {}, // 初始传入的代理机构信息
      agentListPage: {
        total: 0,
        page: 1,
        size: 6
      },

      // 员工查询
      name: '',
      tempName: '', // 临时存储员工名称，为了翻页时候回显
      employeeList: [],
      currentEmployeeInfo: {}, // 选中行员工
      initEmployeeInfo: {}, // 初始传入的员工信息
      employeeListPage: {
        total: 0,
        page: 1,
        size: 6
      }
    }
  },

  computed: {
    ...mapState('company', ['companyId'])
  },

  methods: {
    handleClose() {
      this.currentCompanyInfo = {}
      this.currentEmployeeInfo = {}
      this.dialogVisible = false
    },

    /**
     * 打开弹窗
     */
    open(data) {
      this.dialogVisible = true
      this.searchAgentList()
      if (data.companyId) {
        this.initCompanyInfo = {
          companyId: data.companyId
        }
        this.initEmployeeInfo = {
          employeeId: data.employeeId
        }
      }
    },

    /**
     * 点击查询代理机构列表
     */
    searchAgentList() {
      this.agentListPage.page = 1
      // 为了翻页的时候，能按之前的搜索条件搜索
      this.tempKeyword = this.keyword
      this.getAgentList()
    },

    /**
     * 查询获取代理机构列表
     */
    async getAgentList() {
      this.keyword = this.tempKeyword
      try {
        const _data = await searchAgencyListApi({
          keyword: this.keyword,
          page: this.agentListPage.page,
          size: this.agentListPage.size
        })
        this.agentListPage.total = _data.data.total
        this.agentList = _data.data.records

        // 当未选中代理机构，并且有之前选中的代理机构信息，则默认回显之前选中的代理机构
        if (
          this.initCompanyInfo.companyId &&
          !this.currentCompanyInfo.companyId
        ) {
          const _el = this.agentList.find(
            el => el.companyId === this.initCompanyInfo.companyId
          )
          this.$refs.agentTable.setCurrentRow(_el)
        }
      } catch (err) {
        this.$message.error(err.message || '获取代理机构列表失败')
      }
    },

    /**
     * 选择代理机构
     */
    handleAgentCurrentChange(row, oldRow) {
      if (!row) return
      // 代理机构选择，要排除自己
      if (row.companyId === this.companyId) {
        this.$refs.agentTable.setCurrentRow(oldRow)
        return
      }
      this.currentCompanyInfo = { ...row }
      if (this.currentCompanyInfo.companyId) {
        this.searchEmployeeList()
      }
    },

    /**
     * 点击查询员工列表
     */
    searchEmployeeList() {
      if (!this.currentCompanyInfo.companyId) {
        this.$message.warning('请先选择代理机构')
        return
      }
      this.employeeListPage.page = 1
      // 为了翻页的时候，能按之前的搜索条件搜索
      this.tempName = this.name
      this.getEmployeeList()
    },

    /**
     * 获取员工列表
     */
    async getEmployeeList() {
      this.name = this.tempName
      try {
        const _data = await getEmployeeListHasAgencyApi({
          companyId: this.currentCompanyInfo.companyId,
          name: this.name,
          page: this.employeeListPage.page,
          size: this.employeeListPage.size
        })
        this.employeeListPage.total = _data.data.total
        this.employeeList = _data.data.records

        // 当未选中员工，并且有之前选中的员工信息，则默认回显之前选中的员工
        if (
          this.initEmployeeInfo.employeeId &&
          !this.currentEmployeeInfo.employeeId
        ) {
          const _el = this.employeeList.find(
            el => el.employeeId === this.initEmployeeInfo.employeeId
          )
          console.log(_el)
          this.$refs.employeeTable.setCurrentRow(_el)
        }
      } catch (err) {
        this.$message.error(err.message || '获取代理机构列表失败')
      }
    },

    /**
     * 选择员工
     */
    handleEmployeeCurrentChange(row) {
      this.currentEmployeeInfo = { ...row }
    },

    /**
     * 确定代理机构
     */
    submitAgency() {
      if (!this.currentCompanyInfo.companyId) {
        this.$message.warning('请先选择代理机构')
        return
      }

      if (!this.currentEmployeeInfo.employeeId) {
        this.$message.warning('请先选择员工')
        return
      }

      this.$emit('submitAgent', {
        ...this.currentCompanyInfo,
        ...this.currentEmployeeInfo
      })

      this.handleClose()
    }
  }
}
</script>
<style lang="scss" scoped>
.red-dot {
  color: $danger-color;
  margin-right: 4px;
}
.l-inbox {
  display: flex;
  .l-left {
    width: 45%;
    background: $body-background-color;
    ::v-deep {
      .pagination-container,
      .el-pager li,
      .el-table th,
      .el-table tr,
      .el-pagination button {
        background: $body-background-color;
      }
      .pagination-container {
        text-align: left;
      }
    }
  }
  .l-right {
    margin-left: 40px;
    width: calc(55% - 40px);
    .employee-search-tip {
      margin-top: 60px;
      width: 90%;
      color: $info-color;
      text-align: center;
      font-size: 16px;
    }
    ::v-deep {
      .pagination-container {
        text-align: right;
      }
    }
  }
}
::v-deep {
  .el-table tr {
    cursor: pointer;
  }
  .el-input-group__append {
    color: $white-color;
    button.el-button {
      border-radius: 0;
    }
  }

  .el-table__row {
    span {
      display: block;
      &.disabled {
        cursor: not-allowed;
        color: $info-color;
      }
    }
  }

  .el-table__body tr.current-row > td {
    color: $primary-color;
  }

  .el-table--enable-row-hover .el-table__body tr:hover > td {
    color: $primary-color;
  }

  .el-input-group__append button {
    background-color: $primary-color;
    border-color: $primary-color;
  }
}
</style>
